<template>
  <div>
    <div class="card">
      <div class="card-image workscover">
        <b-image
          :src='"https://i.ytimg.com/vi_webp/" + youtubeId + "/mqdefault.webp"'
          :webp-fallback='"https://i.ytimg.com/vi/" + youtubeId + "/mqdefault.jpg"'
          :alt="title"
          @load="setFallbackImageUrl"
          :vt-id="youtubeId"
          ratio="16by9"
        >
          <b-skeleton
            :animated="false"
            class="skeleton-placeholder skeleton"
            slot="placeholder"
            height="100%"
            :rounded="false"
          ></b-skeleton>
        </b-image>
        <div class="card-content is-overlay" style="background-color: rgba(200,200,200,0.3);"></div>
      </div>
    </div>
    <div class="pt-2">
      <div class="media">
        <div class="media-content">
          <p class="title is-6 is-size-7-mobile is-text-overflow text-offset" v-html="title">
            {{ title }}
          </p>
        </div>
      </div>
      <div class="content">
        <p
          class="is-size-7 is-text-overflow has-text-weight-medium has-text-dark"
          v-html="channelTitle"
        >
          {{ channelTitle }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'video-item',
  props: {
    youtubeId: String,
    title: String,
    channelTitle: String,
  },
  data() {
    return {
      counter: 0,
    };
  },
  methods: {
    setFallbackImageUrl(event) {
      const image = (event.path === undefined) ? event.target : event.path[0];
      let id;
      if (image) {
        id = image.parentElement.getAttribute('vt-id');

        if (image.naturalWidth === 120 && id && this.counter < 3) {
          image.src = `https://i.ytimg.com/vi/${id}/mqdefault.jpg`;
          this.counter += 1;
        }
      } else {
        id = null;
      }
    },
  },
};
</script>

<style scoped>
/deep/ .b-skeleton {
  height: 100%;
  position: absolute;
  top: 0;
}
.card {
  overflow: hidden;
}
.workscover {
  -webkit-filter: grayscale(50%);
  filter: grayscale(50%);
  /* -webkit-transform: scale(1);
  transform: scale(1); */
  -webkit-transition: -webkit-transform 7s cubic-bezier(0,.6,.45,1);
  transition: transform 7s cubic-bezier(0,.6,.45,1);
}
.workscover:hover {
  -webkit-filter: grayscale(0%);
  filter: grayscale(0%);
  /* -webkit-transform: scale(1.15);
  transform: scale(1.15); */
  -webkit-transition: -webkit-transform 7s cubic-bezier(0,.6,.45,1);
  transition: transform 7s cubic-bezier(0,.6,.45,1);
  border-radius: 0.3rem;
}

/deep/ em {
  color: #b60000; /* */
  font-style: normal;
}
</style>
